// extracted by mini-css-extract-plugin
export default {"root":"H58AX","submit":"TPzsQ"};